














import Vue from "vue";

interface Organizer {
  name: string;
  img?: string;
  about: string;
  mision?: string;
}

export interface HomeComponentData {
  organizers: Organizer[];
}

const Organizers = Vue.extend({
  data(): HomeComponentData {
    return {
      organizers: [
        {
          name: "Universidad de Nariño",
          img: "/images/universidades/udenar.jpg",
          about:
            "La Universidad de Nariño es una institución pública de educación superior ubicada en la ciudad de Pasto, en el departamento de Nariño, Colombia. Fue fundada en 1827 y cuenta con una amplia trayectoria en la formación de profesionales en diversas áreas del conocimiento.La universidad es reconocida por su contribución a la cultura y la formación de valores humanos, así como por su compromiso con la paz, la convivencia y la justicia social. Además, se enfoca en la formación académica e investigativa, y en el desarrollo regional en una dimensión intercultural.En el año 2025, La Universidad de Nariño imparte 31 carreras universitarias y 58 posgrados.",
        },
        {
          name: "Universidad Mariana",
          img: "/images/universidades/mariana.jpg",
          mision:
            "La Universidad Mariana es una institución de educación superior, católica y privada. Forma profesionales humana y académicamente competentes, con espíritu crítico, sentido ético y compromiso social. Mediante la interacción con el entorno y el diálogo entre fe, ciencia y cultura contribuye a la transformación sociocultural y al desarrollo con justicia social y respeto por el ambiente, desde el Evangelio de Jesucristo y la espiritualidad mariana y franciscana.",
          about: `Desde su fundación, la Universidad Mariana contribuye con el desarrollo y transformación del entorno social, educativo, ecológico, político, económico y cultural a través de las actividades realizadas desde sus diferentes facultades en todas sus modalidades. Consolidada como una institución de carácter privado que cuenta con 6 facultades las cuales abarcan los programas de pregrado y postgrado en áreas de la salud, humanidades, ingeniería, educación, economía y relaciones internacionales.`,
        },
        {
          name: "Universidad CESMAG",
          img: "/images/universidades/cesmag.jpg",
          about:
            "La Universidad Cesmag es una entidad educativa de origen católico franciscano y de carácter privado que promueve la formación ética y profesional para contribuir mediante su cuerpo académico a la formación y contribución hacia una sociedad justa, solidaria y respetuosa del ser humano y la creación. Actualmente cuenta con 5 facultades que abarcan los 12 programas de pregrado y 5 programas de posgrado.",
        },
        // {
        //   name: "Universidad Nacional Abierta y a Distancia (UNAD)",
        //   img: "/images/universidades/unad.png",
        //   about: `La Universidad Nacional Abierta y a Distancia, (UNAD) es un Proyecto Educativo que nació con el nombre de Unidad Universitaria del Sur de Bogotá, UNISUR durante el gobierno de Belisario Betancur. <br/><br/>
        //   Surgió, mediante la Ley 52 de 1981, como un establecimiento público del orden nacional adscrito al Ministerio de Educación Nacional y transformada por el Congreso de la República mediante la Ley 396 del 5 de agosto de 1997 en la Universidad Nacional Abierta y a Distancia UNAD. <br/><br/>
        //   Se creó con el objeto de diseñar e implementar programas académicos con la estrategia pedagógica de la educación a distancia, que fuesen pertinentes con las necesidades locales, regionales, nacionales e internacionales y acordes con los retos y las demandas de una sociedad democrática, participativa y dinámica afines con modelos científicos, sociales y culturales que contextualizan al siglo XXI.`,
        // },
        // {
        //   name: "Colegio Mayor del Cauca",
        //   img: "/images/universidades/colegioMayor.jpg",
        //   about: `El Colegio Mayor del Cauca creado por la Ley 48 de 1945, inició su labor académica el 13 de noviembre de 1967. En el año 2008 se expide la Resolución 5858 por medio de la cual se modifica su carácter académico a INSTITUCIÓN UNIVERSITARIA. Es un Establecimiento Público del orden departamental, de carácter académico, con personería jurídica, autonomía administrativa, patrimonio independiente y con domicilio en la ciudad de Popayán. <br/><br/>
        //   La Institución Universitaria Colegio Mayor del Cauca, UNIMAYOR, es una Institución Pública de Educación Superior, con amplia experiencia en la formación de nuevos profesionales, una gran variedad de programas y proyectos investigativos, de bienestar, proyección social, relacionamiento con el entorno, entre otros. Cuenta con un total de cuatro (4) Facultades, distribuidas en cuatro (4) sedes.`,
        // },
      ],
    };
  },
});

export default Organizers;
